// UNIVERSAL WORD ANIMATE SCRIPT
// This handles any element with "word-animate" class anywhere on the site

(function() {
  'use strict';
  
  console.log('Word Animate Script Loaded');
  
  // Initialize word animate elements
  function initializeWordAnimate() {
    const wordAnimateElements = document.querySelectorAll('.word-animate');
    const lineAnimateElements = document.querySelectorAll('.line-animate');
    
    console.log('🚀 INITIALIZING:', wordAnimateElements.length, 'word-animate elements and', lineAnimateElements.length, 'line-animate elements found');
    
    // Log each word-animate element found
    wordAnimateElements.forEach((element, index) => {
      console.log(`🔍 Word Element ${index}:`, {
        textContent: element.textContent.trim(),
        className: element.className,
        parentClassName: element.parentElement?.className,
        initialized: element.hasAttribute('data-word-animate-initialized')
      });
    });
    
    // Log each line-animate element found
    lineAnimateElements.forEach((element, index) => {
      console.log(`🔍 Line Element ${index}:`, {
        textContent: element.textContent.trim(),
        className: element.className,
        parentClassName: element.parentElement?.className,
        initialized: element.hasAttribute('data-line-animate-initialized')
      });
    });
    
    wordAnimateElements.forEach((element, index) => {
      // Skip if already initialized
      if (element.hasAttribute('data-word-animate-initialized')) {
        console.log(`⚠️ Element ${index} already initialized, skipping`);
        return;
      }
      
      const originalText = element.textContent.trim();
      const words = originalText.split(' ');
      
      console.log(`🔧 Initializing element ${index} with text: "${originalText}"`);
      
      // Create simple line and word structure
      const line = document.createElement('div');
      line.className = 'line';
      
      // Create word divs
      words.forEach((wordText, wordIndex) => {
        const wordDiv = document.createElement('div');
        wordDiv.className = 'word';
        wordDiv.textContent = wordText;
        line.appendChild(wordDiv);
        
        // Add space between words (except last)
        if (wordIndex < words.length - 1) {
          line.appendChild(document.createTextNode(' '));
        }
      });
      
      // Replace original content with word structure
      element.innerHTML = '';
      element.appendChild(line);
      
      // Start with hidden state
      element.classList.add('hide-words');
      element.classList.remove('show-words', 'slide-up-out');
      
      // Clear any existing inline styles
      const wordElements = element.querySelectorAll('.word');
      wordElements.forEach(word => {
        word.style.transform = '';
        word.style.opacity = '';
        word.style.transition = '';
      });
      
      // Mark as initialized with unique ID for tracking
      element.setAttribute('data-word-animate-initialized', 'true');
      element.setAttribute('data-word-animate-id', `word-animate-${index}-${Date.now()}`);
      
      console.log(`✅ Element ${index} initialized successfully with ${words.length} words (ID: ${element.getAttribute('data-word-animate-id')})`);
    });
    
    // Initialize line-animate elements (for subheadings)
    lineAnimateElements.forEach((element, index) => {
      // Skip if already initialized
      if (element.hasAttribute('data-line-animate-initialized')) {
        console.log(`⚠️ Line Element ${index} already initialized, skipping`);
        return;
      }
      
      const originalText = element.textContent.trim();
      // Split by sentences or use manual line breaks if present
      const lines = originalText.includes('\n') 
        ? originalText.split('\n') 
        : originalText.split('. ').map(line => line.includes('.') ? line : line + '.');
      
      console.log(`🔧 Initializing line element ${index} with text: "${originalText}" (${lines.length} lines)`);
      
      // Create line container
      const lineContainer = document.createElement('div');
      lineContainer.className = 'line';
      
      // Create line-text divs
      lines.forEach((lineText, lineIndex) => {
        if (lineText.trim()) { // Only create if line has content
          const lineDiv = document.createElement('div');
          lineDiv.className = 'line-text';
          lineDiv.textContent = lineText.trim();
          lineContainer.appendChild(lineDiv);
        }
      });
      
      // Replace original content with line structure
      element.innerHTML = '';
      element.appendChild(lineContainer);
      
      // Start with hidden state
      element.classList.add('hide-lines');
      element.classList.remove('show-lines', 'slide-down-out');
      
      // Clear any existing inline styles
      const lineElements = element.querySelectorAll('.line-text');
      lineElements.forEach(line => {
        line.style.transform = '';
        line.style.opacity = '';
        line.style.transition = '';
      });
      
      // Mark as initialized with unique ID for tracking
      element.setAttribute('data-line-animate-initialized', 'true');
      element.setAttribute('data-line-animate-id', `line-animate-${index}-${Date.now()}`);
      
      console.log(`✅ Line Element ${index} initialized successfully with ${lines.length} lines (ID: ${element.getAttribute('data-line-animate-id')})`);
    });
  }
  
  // Show line animate elements with forced animation
  function showLineAnimate(elements) {
    console.log('🟢 SHOW LINE ANIMATION STARTED for', elements.length, 'elements');
    console.log('🟢 Line Elements array:', Array.from(elements).map((el, i) => ({
      index: i,
      text: el.textContent.trim(),
      className: el.className,
      trackingId: el.getAttribute('data-line-animate-id') || 'no-tracking-id'
    })));
    
    elements.forEach((element, index) => {
      console.log(`🟢 Line Element ${index} [${element.getAttribute('data-line-animate-id')}] BEFORE:`, {
        text: element.textContent.trim(),
        classList: Array.from(element.classList)
      });
      
      // Force reset first - include slide-down-out to prevent conflicts
      element.classList.remove('show-lines', 'slide-down-out');
      element.classList.add('hide-lines');
      
      // Force reflow
      element.offsetHeight;
      
      // Use requestAnimationFrame for proper timing
      requestAnimationFrame(() => {
        // CRITICAL: Remove ALL conflicting classes before adding show-lines
        console.log(`🟢 BEFORE class change - Line Element ${index} classes:`, Array.from(element.classList));
        element.classList.remove('hide-lines', 'slide-down-out');
        element.classList.add('show-lines');
        console.log(`🟢 AFTER class change - Line Element ${index} classes:`, Array.from(element.classList));
        
        // CRITICAL: Clear any inline styles that override CSS
        const lineTexts = element.querySelectorAll('.line-text');
        lineTexts.forEach((lineText, lineIndex) => {
          lineText.style.transform = '';
          lineText.style.opacity = '';
          lineText.style.transition = '';
          console.log(`🟢 Cleared inline styles for line ${lineIndex}`);
        });
        
        console.log(`🟢 Line Element ${index} [${element.getAttribute('data-line-animate-id')}] AFTER:`, {
          text: element.textContent.trim(),
          classList: Array.from(element.classList)
        });
      });
    });
  }

  // Hide line animate elements with forced animation
  function hideLineAnimate(elements, direction = 'down') {
    console.log(`🔴 HIDE LINE ANIMATION STARTED for ${elements.length} elements (direction: ${direction})`);
    console.log('🔴 Line Elements array:', Array.from(elements).map((el, i) => ({
      index: i,
      text: el.textContent.trim(),
      className: el.className,
      trackingId: el.getAttribute('data-line-animate-id') || 'no-tracking-id'
    })));
    
    elements.forEach((element, index) => {
      console.log(`🔴 Line Element ${index} [${element.getAttribute('data-line-animate-id')}] BEFORE:`, {
        text: element.textContent.trim(),
        classList: Array.from(element.classList)
      });
      
      // Force reset first - include slide-down-out to prevent conflicts
      element.classList.remove('hide-lines', 'slide-down-out');
      element.classList.add('show-lines');
      
      // Force reflow
      element.offsetHeight;
      
      // Use requestAnimationFrame for proper timing
      requestAnimationFrame(() => {
        element.classList.remove('show-lines', 'slide-down-out');
        
        if (direction === 'up') {
          // CRITICAL: Remove show-lines first to prevent conflicts
          element.classList.remove('show-lines');
          element.classList.add('slide-down-out');
          console.log(`🔽 Line Element ${index} SLIDE-DOWN-OUT applied (scroll up → slide down)`);
          
          // ALSO apply inline styles as backup (NO rotation for subheadings)
          const lineTexts = element.querySelectorAll('.line-text');
          lineTexts.forEach((lineText, lineIndex) => {
            lineText.style.transform = 'translateY(200%)'; // NO rotation
            lineText.style.opacity = '0';
            lineText.style.transition = `all 0.3s ease ${300 + (lineIndex * 100)}ms`;
            console.log(`🔽 Line ${lineIndex} slide-down-out inline styles applied`);
          });
        } else {
          // For scroll down - hide lines one by one
          element.classList.add('hide-lines');
          console.log(`🔽 Line Element ${index} HIDE-LINES applied (scroll down → hide lines)`);
          
          // Apply inline styles for line-by-line hiding
          const lineTexts = element.querySelectorAll('.line-text');
          lineTexts.forEach((lineText, lineIndex) => {
            lineText.style.transform = 'translateY(100%)'; // Hide below
            lineText.style.opacity = '0';
            lineText.style.transition = `all 0.3s ease ${300 + (lineIndex * 100)}ms`;
            console.log(`🔽 Line ${lineIndex} hide-lines inline styles applied`);
          });
        }
        
        const finalClass = direction === 'up' ? 'slide-down-out' : 'hide-lines';
        console.log(`🔴 Line Element ${index} [${element.getAttribute('data-line-animate-id')}] AFTER (${finalClass}):`, {
          text: element.textContent.trim(),
          classList: Array.from(element.classList)
        });
      });
    });
  }

  // Show word animate elements with forced animation
  function showWordAnimate(elements) {
    console.log('🟢 SHOW ANIMATION STARTED for', elements.length, 'elements');
    console.log('🟢 Elements array:', Array.from(elements).map((el, i) => ({
      index: i,
      text: el.textContent.trim(),
      className: el.className,
      trackingId: el.getAttribute('data-word-animate-id') || 'no-tracking-id'
    })));
    
    elements.forEach((element, index) => {
             // Check all parent containers for display:none
       let parentChain = [];
       let currentParent = element.parentElement;
       while (currentParent && currentParent !== document.body) {
         const computedStyle = getComputedStyle(currentParent);
         parentChain.push({
           tagName: currentParent.tagName.toLowerCase(),
           className: currentParent.className,
           display: computedStyle.display,
           visibility: computedStyle.visibility
         });
         currentParent = currentParent.parentElement;
       }
       
               console.log(`🟢 Element ${index} [${element.getAttribute('data-word-animate-id')}] BEFORE:`, {
          text: element.textContent.trim(),
          classList: Array.from(element.classList),
          display: getComputedStyle(element).display,
          visibility: getComputedStyle(element).visibility,
          parentChain: parentChain
        });
      
      // Check first word's current state
      const firstWord = element.querySelector('.word');
      if (firstWord) {
        const computedStyle = getComputedStyle(firstWord);
        console.log(`🟢 Element ${index} First Word BEFORE:`, {
          transform: computedStyle.transform,
          opacity: computedStyle.opacity,
          transition: computedStyle.transition
        });
      }
      
              // Force reset first - include slide-up-out to prevent conflicts
        element.classList.remove('show-words', 'slide-up-out');
        element.classList.add('hide-words');
      console.log(`🟢 Element ${index} RESET to hide-words`);
      
      // Force reflow
      element.offsetHeight;
      
      // Use requestAnimationFrame for proper timing
      requestAnimationFrame(() => {
        // CRITICAL: Remove ALL conflicting classes before adding show-words
        console.log(`🟢 BEFORE class change - Element ${index} classes:`, Array.from(element.classList));
        element.classList.remove('hide-words', 'slide-up-out');
        element.classList.add('show-words');
        console.log(`🟢 AFTER class change - Element ${index} classes:`, Array.from(element.classList));
        
        // CRITICAL: Clear any inline styles that override CSS
        const words = element.querySelectorAll('.word');
        words.forEach((word, wordIndex) => {
          word.style.transform = '';
          word.style.opacity = '';
          word.style.transition = '';
          console.log(`🟢 Cleared inline styles for word ${wordIndex}`);
        });
        
        console.log(`🟢 Element ${index} [${element.getAttribute('data-word-animate-id')}] AFTER:`, {
          text: element.textContent.trim(),
          classList: Array.from(element.classList),
          display: getComputedStyle(element).display,
          visibility: getComputedStyle(element).visibility
        });
        
        // Check word state after change
        if (firstWord) {
          const computedStyleAfter = getComputedStyle(firstWord);
          console.log(`🟢 Element ${index} First Word AFTER:`, {
            transform: computedStyleAfter.transform,
            opacity: computedStyleAfter.opacity,
            transition: computedStyleAfter.transition
          });
        }
      });
    });
  }
  
  // Hide word animate elements with forced animation
  function hideWordAnimate(elements, direction = 'down') {
    console.log(`🔴 HIDE ANIMATION STARTED for ${elements.length} elements (direction: ${direction})`);
    console.log('🔴 Elements array:', Array.from(elements).map((el, i) => ({
      index: i,
      text: el.textContent.trim(),
      className: el.className,
      trackingId: el.getAttribute('data-word-animate-id') || 'no-tracking-id'
    })));
    
    elements.forEach((element, index) => {
             // Check all parent containers for display:none
       let parentChain = [];
       let currentParent = element.parentElement;
       while (currentParent && currentParent !== document.body) {
         const computedStyle = getComputedStyle(currentParent);
         parentChain.push({
           tagName: currentParent.tagName.toLowerCase(),
           className: currentParent.className,
           display: computedStyle.display,
           visibility: computedStyle.visibility
         });
         currentParent = currentParent.parentElement;
       }
       
               console.log(`🔴 Element ${index} [${element.getAttribute('data-word-animate-id')}] BEFORE:`, {
          text: element.textContent.trim(),
          classList: Array.from(element.classList),
          display: getComputedStyle(element).display,
          visibility: getComputedStyle(element).visibility,
          parentChain: parentChain
        });
      
      // Check first word's current state
      const firstWord = element.querySelector('.word');
      if (firstWord) {
        const computedStyle = getComputedStyle(firstWord);
        console.log(`🔴 Element ${index} First Word BEFORE:`, {
          transform: computedStyle.transform,
          opacity: computedStyle.opacity,
          transition: computedStyle.transition
        });
      }
      
      // Force reset first - include slide-up-out to prevent conflicts
      element.classList.remove('hide-words', 'slide-up-out');
      element.classList.add('show-words');
      console.log(`🔴 Element ${index} RESET to show-words`);
      
      // Force reflow
      element.offsetHeight;
      
      // Use requestAnimationFrame for proper timing
      requestAnimationFrame(() => {
        element.classList.remove('show-words', 'slide-up-out');
        
        if (direction === 'up') {
          // CRITICAL: Remove show-words first to prevent conflicts
          element.classList.remove('show-words');
          element.classList.add('slide-up-out');
          console.log(`🔼 Element ${index} SLIDE-UP-OUT applied (scroll up → slide up like main heading)`);
          
          // ALSO apply inline styles as backup (slide UP and out like main heading)
          const words = element.querySelectorAll('.word');
          words.forEach((word, wordIndex) => {
            word.style.transform = 'translateY(-100%) rotate(-10deg)';
            word.style.opacity = '0';
            word.style.transition = `all 0.3s ease ${200 + (wordIndex * 100)}ms`;
            console.log(`🔼 Word ${wordIndex} slide-up-out inline styles applied`);
          });
        } else {
          element.classList.add('hide-words');
          console.log(`🔽 Element ${index} HIDE-WORDS applied`);
        }
        
                                         const finalClass = direction === 'up' ? 'slide-up-out' : 'hide-words';
        console.log(`🔴 Element ${index} [${element.getAttribute('data-word-animate-id')}] AFTER (${finalClass}):`, {
          text: element.textContent.trim(),
          classList: Array.from(element.classList),
          display: getComputedStyle(element).display,
          visibility: getComputedStyle(element).visibility
        });
        
        // Check word state after change
        if (firstWord) {
          const computedStyleAfter = getComputedStyle(firstWord);
          console.log(`🔴 Element ${index} First Word AFTER:`, {
            transform: computedStyleAfter.transform,
            opacity: computedStyleAfter.opacity,
            transition: computedStyleAfter.transition
          });
          
          // Check again after a delay to see if transition actually happened
          setTimeout(() => {
            const computedStyleDelayed = getComputedStyle(firstWord);
            console.log(`🔴 Element ${index} First Word DELAYED CHECK (500ms):`, {
              transform: computedStyleDelayed.transform,
              opacity: computedStyleDelayed.opacity,
              transition: computedStyleDelayed.transition,
              display: computedStyleDelayed.display,
              visibility: computedStyleDelayed.visibility,
              finalClass: direction === 'up' ? 'slide-up-out' : 'hide-words',
              elementClasses: Array.from(element.classList),
              parentDisplay: getComputedStyle(element.parentElement).display,
              grandParentDisplay: getComputedStyle(element.parentElement.parentElement).display
            });
          }, 500);
        }
      });
    });
  }
  
  // Expose functions globally for banner script to use
  window.WordAnimate = {
    initialize: initializeWordAnimate,
    show: showWordAnimate,
    hide: hideWordAnimate,
    showLines: showLineAnimate,
    hideLines: hideLineAnimate
  };
  
  // Auto-initialize on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeWordAnimate);
  } else {
    initializeWordAnimate();
  }
  
})(); 